export const experienceData = [
    {
        id: 1,
        company: 'Electrum Payments',
        jobtitle: 'Software Engineer',
        startYear: 'Nov 2023',
        endYear: 'present'
    },
    {
        id: 2,
        company: 'Polymorph System',
        jobtitle: 'Software Engineer',
        startYear: '2023 Jan',
        endYear: '2023 Oct'
    },
    {
        id: 3,
        company: 'Electrum Payments',
        jobtitle: 'Intern Software Engineer',
        startYear: 'July 2021',
        endYear: 'July 2021'
    },
    {
        id: 3,
        company: 'Polymorph Systems',
        jobtitle: 'Intern Software Engineer',
        startYear: 'Nov 2019',
        endYear: 'Jan 2020'
    },
]